export default "__VITE_ASSET__BE_F3imT__"